<template>
  <ModalXD>
    <div class="installation-container" v-if="installation">
      <div class="input-wrapper">
        <h1 class="title">Rediger installasjon</h1>
      </div>
      <div class="input-wrapper">
        <div>
          <label for=""> ID: </label>
          <input type="number" placeholder="Id" v-model="installation.id" />
        </div>
        <div>
          <label> Tittel: </label>
          <input type="text" placeholder="Tittel" v-model="installation.title" />
        </div>
        <div>
          <label> Forfatter: </label>
          <input type="text" placeholder="Forfatter" v-model="installation.author" />
        </div>
      </div>
      <div class="input-wrapper">
        <div>
          <label> Lese-Link: </label>
          <input type="text" placeholder="Link" v-model="installation.link" />
          <label> Lytte-Link: </label>
          <input type="text" placeholder="Link" v-model="installation.musicLink" />
        </div>
        <div>
          <label> Sted: </label>
          <input type="text" placeholder="Sted" v-model="installation.location" />
        </div>
        <div>
          <label> Koordinater: </label>
          <button @click="toggleGoogleMapsModal">Velg Koordinater</button>
          <span>Høyde: <input type="number" v-model="installation.position.lat" /></span>
          <br />
          <span>Bredde: <input type="number" v-model="installation.position.lng" /></span>
        </div>
      </div>
      <div class="input-wrapper">
        <div class="image-container" v-if="imageChanged">
          <p>Nytt bilde valgt</p>
        </div>
        <div class="image-container" v-else>
          <img :src="installation.img" alt="Bilde" id="image-view" />
          <div></div>
          <div></div>
          <div></div>
        </div>
        <input type="file" ref="installationfile" class="image-selector" accept="image/*"
          @change="file = $event.target.files[0];" />
      </div>
      <div class="input-wrapper">
        <div>
          <label> Bidragsyter: </label>
          <input type="text" v-model="installation.sponsor" />
        </div>
      </div>
      <div class="input-wrapper">
        <div>
          <label> Innhold: </label>
          <Editor api-key="l3hxtpsgpdlf3ypuwfuqta730sunu7tbe9u1kqc4kjgdvxds" :init="{
            height: 200,
            toolbar_mode: 'sliding',
            plugins: [
              // Core editing features
              'autolink',
              'lists',
              'searchreplace',
              'table',
              'wordcount',
            ],
            toolbar:
              'undo redo | blocks fontfamily fontsize | bold italic underline strikethrough | align lineheight | checklist numlist bullist indent outdent | removeformat',
            tinycomments_mode: 'embedded',
            tinycomments_author: 'Author name',
          }" initial-value="Welcome to TinyMCE!" v-model="installation.content" />
        </div>
      </div>
      <div class="input-wrapper">
        <button @click="updateInstallation">
          Oppdater<span class="material-icons">publish</span>
        </button>
        <button @click="cancelUpdate" class="cancel-button">
          Avbryt<span class="material-icons">cancel</span>
        </button>
      </div>
      <div id="g-map-wrapper" v-if="gMapOpen">
        <GoogleMap id="g-map" class="map" api-key="AIzaSyAZx4cMuWZ8ZoqddymU6G_TYpu5D0NSofg" :center="center"
          :zoom="zoomLevel" mapTypeId="satellite" @click="getCoordinates">
          <GmapCustomMarker :marker="installation.position">
            <img loading="lazy" src="@/assets/poesi-cursor.png" alt="bilde av kart-markør" />
          </GmapCustomMarker>
        </GoogleMap>
        <p>
          Valgte koordinater er:
          <span>Høyde: {{ installation.position.lat }}, </span>
          <span>Bredde: {{ installation.position.lng }}</span>
          <button class="close-modal-button" @click="toggleGoogleMapsModal">
            Bekreft koordinater
          </button>
        </p>
      </div>
    </div>
  </ModalXD>
</template>

<script>
import Editor from "@tinymce/tinymce-vue";
import ModalXD from "@/components/ModalXD.vue";
import { GoogleMap } from "vue3-google-map";
import GmapCustomMarker from "vue3-gmap-custom-marker"; import { getFirestore, doc, setDoc } from "firebase/firestore";
import { getStorage, ref as storageRef, uploadBytes, getDownloadURL } from "firebase/storage";
export default {
  name: "ModalInstallationEdit",
  components: {
    Editor,
    ModalXD,
    GoogleMap,
    GmapCustomMarker,
  },
  props: {
    selectedInstallation: Object,
  },
  data() {
    return {
      gMapOpen: false,
      center: { lat: 59.05328, lng: 10.03517 }, //Larvik, Norge
      zoomLevel: 12,
      file: null,
      installation: null,
      imageChanged: false,
      downloadUrl: null,
      sponsors: [
        "Sparebank1",
        "Gjensidigestiftelsen",
        "Poesiparken",
        "Larvik kommune",
        "NLI/Poesiparken/Gjensidigestiftelsen",
        "Arnes Fargehandel",
        "Kaare Mortensen AS",
        "Lundhs AS",
        "Biblioteksystemer AS",
        "Larvik Boligbyggelag",
        "Larvikbanken",
        "Reguline AS. v/ Kari Line Roald",
        "Gave fra F.G.Fritzøe Minnefond",
        "Amfi Larvik",
        "Farris Bad",
        "Grand-kvartalet",
        "DNB, Ernst-Young AS, Abax AS",
        "NOPA, Lundhs AS, Hübert AS, Nasta AS og Bjørn og Øyvind Tveter AS",
        "Larvik Havn",
        "Ingers Hage",
        "LO-senteret",
        "Handelsbanken",
        "Ecbos legater",
        "Per Fuhre Pettersen",
        "Strandberg Stein og NOPA",
        "Vestfold kollektivtrafikk",
        "Lundhs AS Larvik Havn og Heyerdahlinstituttet",
        "Larvik og omegn Turistforening",
        "Larvik By og Poesiparkens Venner",
        "http://www.klemmetsby-firing.no/",
        "Tuppen Roalds barn",
        "Fritzøe Eiendom og Larvik kommune",
        "Bergene Holm AS",
        "Poesiparkens venner",
        "Danske Bank/Poesiparken",
        "Tore Hansen/Poesiparken",
        "Håkon Ebbing/Poesiparken",
      ],
    };
  },
  mounted() {
    this.getInstallation();
  },
  watch: {
    file(newFile) {
      this.imageChanged = !!newFile;
    },
  },
  methods: {
    getInstallation() {
      this.installation = this.selectedInstallation;
    },
    fileName(e) {
      this.selectedFile = e.target.files[0].name;
    },
    toggleGoogleMapsModal() {
      this.gMapOpen = !this.gMapOpen;
    },
    getCoordinates(e) {
      this.installation.position.lat = e.latLng.lat();
      this.installation.position.lng = e.latLng.lng();
    },


async updateInstallation() {
  try {
    const db = getFirestore();
    const storage = getStorage();

    // 1️⃣ Build safe payload for Firestore
    let payload = {
      title: String(this.installation.title || ""),
      description: String(this.installation.description || ""),
      author: String(this.installation.author || ""),
      content: String(this.installation.content || ""),
      link: String(this.installation.link || ""),
      musicLink: String(this.installation.musicLink || ""),
      sponsor: String(this.installation.sponsor || ""),
      location: String(this.installation.location || ""),
      position: {
        lat: Number(this.installation.position.lat),
        lng: Number(this.installation.position.lng),
      },
    };

    // 2️⃣ Handle image upload
    if (this.imageChanged && this.file) {
      // create a unique filename to avoid collisions
      const fileName = `${Date.now()}-${this.file.name}`;
      const fileRef = storageRef(storage, `installations/${fileName}`);

      await uploadBytes(fileRef, this.file);
      const downloadUrl = await getDownloadURL(fileRef);

      payload.img = downloadUrl;

      // Update reactive references so the UI shows the new image immediately
      this.installation.img = downloadUrl;
    } else {
      payload.img = this.installation.img || "";
    }

    console.log("Firestore payload:", payload);

    // 3️⃣ Update Firestore document
    const docRef = doc(db, "installations", String(this.installation.id));
    await setDoc(docRef, payload, { merge: true });

    console.log("Installation updated:", this.installation.id);

    // 4️⃣ Reset file input and image state
    this.file = null;
    this.imageChanged = false;

    // 5️⃣ Notify user
    this.$toast.success(payload.img ? "Installasjon oppdatert med bilde!" : "Installasjon oppdatert uten bilde!");

    // Close modal
    this.$emit("close");
  } catch (err) {
    console.error("Update failed:", err);
    this.$toast.error("Oppdatering feilet");
  }
},
    cancelUpdate() {
      this.$emit("update-installation", { ...this.installation });
      this.$emit("close");
    },
  },
};
</script>

<style scoped lang="scss">
.installation-container {
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  overflow-y: scroll;
  overflow-x: hidden;
  height: 80vh;

  .input-wrapper {
    margin: auto;
    display: flex;
    flex-direction: row;
    justify-content: space-evenly;
    align-items: center;
    text-align: center;
    width: 100%;

    * {
      width: 100%;
      margin: 5px;
      margin-right: 15px;
      padding: 0;
    }

    button {
      margin: 0px;
      padding: 20px;
      font-size: 1em;
      background: #2a8355;
      color: white;
      border: none;
      cursor: pointer;
      display: flex;
      align-items: center;
      justify-content: center;
      text-align: center;

      span {
        margin: 0 5px;
        width: fit-content;
      }
    }

    .cancel-button {
      background: #991111;
    }
  }
}

p {
  margin: 0;
  padding: 0;
  font-size: 1em;
}

.txt-ara {
  height: 6em;
  max-width: 100%;
  white-space: pre-wrap;
}

.custom-file-upload {
  padding: 20px;
  font-size: 1em;
  background: #2a8355;
  color: white;
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.tox {
  z-index: 100 !important;
}

#g-map-wrapper {
  position: absolute;
  height: 100vh;
  width: 80vw;
  top: 0vh;
  left: 10vw;
  margin: 0;
  padding: 0;
  background: #fff;
  z-index: 100 !important;

  #g-map {
    display: block;
    margin: 0;
    padding: 0;
    height: calc(100% - 4.5em);
    width: 100%;
  }

  p {
    margin: 0.5em;
    padding: 0.5em;
    text-align: right;
    font-size: 1em;
  }

  .close-modal-button {
    margin: 0.5em;
    padding: 0.5em;
    background-color: #2a8355;
  }
}

.image-container {
  display: flex;
  flex-direction: row;
  height: 64px;
  width: 64px;
}

.image-selector {
  width: 50px;
  border: 1px solid black;
  font-size: 0;
}

::file-selector-button {
  font-size: initial;
}

#image-view {
  height: 100%;
  width: 100%;
}
</style>
